export enum RegionsEnum {
  "KANTO" = "KANTO",
  "JOHTO" = "JOHTO",
  "HOENN" = "HOENN",
  "SINNOH" = "JOHTO",
  "UNOVA" = "JOHTO",
  "KALO" = "JOHTO",
  "GALAR" = "JOHTO",
}
